import React from 'react'
import PropTypes from 'prop-types'
import { Link, navigateTo, withPrefix } from 'gatsby-link'
import Helmet from 'react-helmet'
import { Button,Nav,NavItem, MenuItem, Navbar, NavDropdown } from 'react-bootstrap';

import './index.css'
import '../css/bootstrap.css'
import '../css/bootstrap-theme.css'

function handleSelect(selectedKey) {
		navigateTo(withPrefix(selectedKey));
		return false;
}
const Header = () => (
				<Navbar inverse onSelect={handleSelect}>
				<Navbar.Header>
				<Navbar.Brand><a href="http://www.doc.ic.ac.uk/~hlgr">Holger Pirk</a></Navbar.Brand>
				<Navbar.Toggle/>
				</Navbar.Header>
				<Navbar.Collapse>
				<Nav>
				<NavItem eventKey="/">Overview</NavItem>
				<NavDropdown title="Research" eventKey="research" id="research-dropdown">
				<MenuItem eventKey="/research/publications">Publications</MenuItem>
				<MenuItem eventKey="/research/projects">Projects</MenuItem>
				<MenuItem eventKey="/research/openings">Opportunities</MenuItem>
				<MenuItem eventKey="/research/tipswhenapplying">Tips when applying</MenuItem>
				</NavDropdown>
				<NavDropdown title="Teaching">
				<NavItem eventKey="/teaching/classes">Classes</NavItem>
				<NavItem eventKey="/teaching/projects">Student Projects</NavItem>
				</NavDropdown>
				<NavDropdown title="Industry">
				<NavItem eventKey="/industry/patents">Patents</NavItem>
				<NavItem eventKey="/industry/visits">Visits</NavItem>
				</NavDropdown>
				<NavItem eventKey="/other">Other</NavItem>
				</Nav>
				</Navbar.Collapse>
				</Navbar>
)

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Holger Pirk | Lecturer in Computing at Imperial College London"
      meta={[
        { name: 'description', content: 'I work on high-performance data management. This covers research on data management, systems, compilers, computer architecture and high-performance computing.' },
        { name: 'keywords', content: 'high-performance data management, research, data management, systems, compilers, computer architecture, high-performance computing.' },
      ]}
				>
				</Helmet>
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js